var _circle, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#9C1FE9",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09552 13.191C9.70055 13.191 10.191 12.7006 10.191 12.0955C10.191 11.4905 9.70055 11 9.09552 11C8.49048 11 8 11.4905 8 12.0955C8 12.7006 8.49048 13.191 9.09552 13.191Z",
    fill: "#9C1FE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09552 17.5731C9.70055 17.5731 10.191 17.0826 10.191 16.4776C10.191 15.8725 9.70055 15.3821 9.09552 15.3821C8.49048 15.3821 8 15.8725 8 16.4776C8 17.0826 8.49048 17.5731 9.09552 17.5731Z",
    fill: "#9C1FE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09552 21.9552C9.70055 21.9552 10.191 21.4647 10.191 20.8596C10.191 20.2546 9.70055 19.7641 9.09552 19.7641C8.49048 19.7641 8 20.2546 8 20.8596C8 21.4647 8.49048 21.9552 9.09552 21.9552Z",
    fill: "#9C1FE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.0024C24 11.8571 23.9423 11.7178 23.8396 11.6151C23.7368 11.5123 23.5975 11.4546 23.4522 11.4546H11.7193V12.5502H23.4522C23.5975 12.5502 23.7368 12.4924 23.8396 12.3897C23.9423 12.287 24 12.1477 24 12.0024Z",
    fill: "#9C1FE9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4522 15.8367H11.7193V16.9322H23.4522C23.5975 16.9322 23.7368 16.8745 23.8396 16.7718C23.9423 16.6691 24 16.5297 24 16.3845C24 16.2392 23.9423 16.0999 23.8396 15.9971C23.7368 15.8944 23.5975 15.8367 23.4522 15.8367Z",
    fill: "#9C1FE9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4522 20.2188H11.7193V21.3143H23.4522C23.5975 21.3143 23.7368 21.2566 23.8396 21.1538C23.9423 21.0511 24 20.9118 24 20.7665C24 20.6212 23.9423 20.4819 23.8396 20.3792C23.7368 20.2765 23.5975 20.2188 23.4522 20.2188Z",
    fill: "#9C1FE9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookings);
export default __webpack_public_path__ + "static/media/bookings.89997a46659e191a94a88f035552ace6.svg";
export { ForwardRef as ReactComponent };